import {
  ContactDealerActions,
  DealerInfoCard,
  DealerOverview,
  DeepLinkAction,
} from "@mobility-item-page/dealer/client";
import { isPrivateAdvertiser } from "@mobility-item-page/utilities";
import { useAdViewMeta } from "src/context/AdViewProviderContext.tsx";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";

export const MobileCTAs = () => {
  const { isMobile } = useAppConfig();
  const { ownerUrn } = useAdViewMeta();

  const isPrivateAd = isPrivateAdvertiser(ownerUrn);

  if (!isMobile || isPrivateAd) {
    return null;
  }

  return (
    <div className="mt-16">
      <ContactDealerActions />
      <DealerInfoCard />
      <DeepLinkAction />
    </div>
  );
};

export const DesktopCompanyProfile = () => {
  const { isMobile } = useAppConfig();
  const { ownerUrn } = useAdViewMeta();

  const isPrivateAd = isPrivateAdvertiser(ownerUrn);

  if (isMobile || isPrivateAd) {
    return null;
  }

  return (
    <>
      <ContactDealerActions />
      <DealerInfoCard />
      <DeepLinkAction />
    </>
  );
};

export const EnabledDealerOverview = () => {
  const { ownerUrn } = useAdViewMeta();
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);
  return !isPrivateAd ? <DealerOverview /> : null;
};

export const NoDealerBorder = () => {
  const { ownerUrn } = useAdViewMeta();
  const isPrivateAd = isPrivateAdvertiser(ownerUrn);

  return isPrivateAd ? <div className="border-t mt-40" /> : null;
};
